
namespace GeniuzPOS.Inventory {

    @Serenity.Decorators.registerClass()
    export class IcStkAdjCodeGrid extends Serenity.EntityGrid<IcStkAdjCodeRow, any> {
        protected getColumnsKey() { return IcStkAdjCodeColumns.columnsKey; }
        protected getDialogType() { return IcStkAdjCodeDialog; }
        protected getIdProperty() { return IcStkAdjCodeRow.idProperty; }
        protected getInsertPermission() { return IcStkAdjCodeRow.insertPermission; }
        protected getLocalTextPrefix() { return IcStkAdjCodeRow.localTextPrefix; }
        protected getService() { return IcStkAdjCodeService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
		protected getButtons() {
			var button = super.getButtons();
            
                
                button.push(
                    {
                        title: Q.text("Close"), // *** Get button text from translation
                        cssClass: '.panel-titlebar-close',
                        icon: 'fa-close',
                        onClick: () => {
                            window.location.href = '/';
                            return false;
                        },
                    }
                );            
                
			// button.splice(Q.indexOf(button, x => x.cssClass == "add-button"), 1);
			return button;
		}
    }

}